import { render, staticRenderFns } from "./experimentcertificate.vue?vue&type=template&id=2fd1a7c1&scoped=true&"
import script from "./experimentcertificate.vue?vue&type=script&lang=js&"
export * from "./experimentcertificate.vue?vue&type=script&lang=js&"
import style0 from "./experimentcertificate.vue?vue&type=style&index=0&id=2fd1a7c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd1a7c1",
  null
  
)

export default component.exports